import httpClient from "./httpClient";

const prefix = "/holiday-bonus";

export interface HolidayBonusPriceData {
  id?: number;
  amount: number;
  positionIds: number[];
}

export interface HolidayBonusData {
  id: number;
  date: string; // YYYY-MM-DD format
  title: string;
  prices: HolidayBonusPriceData[];
  createdAt: string;
  updatedAt: string;
}

export interface HolidayBonusResponse {
  bonuses: HolidayBonusData[];
}

export interface CreateHolidayBonusRequest {
  date: string;
  title: string;
  prices: HolidayBonusPriceData[];
}

export interface UpdateHolidayBonusRequest {
  date?: string;
  title?: string;
  prices?: HolidayBonusPriceData[];
}

export async function getHolidayBonuses(): Promise<HolidayBonusResponse> {
  return (await httpClient.get(`${prefix}`)).data;
}

export async function createHolidayBonus(
  data: CreateHolidayBonusRequest
): Promise<HolidayBonusData> {
  return (await httpClient.post(`${prefix}`, data)).data;
}

export async function updateHolidayBonus(
  id: number,
  data: UpdateHolidayBonusRequest
): Promise<HolidayBonusData> {
  return (await httpClient.patch(`${prefix}/${id}`, data)).data;
}

export async function deleteHolidayBonus(id: number): Promise<HolidayBonusResponse> {
  return (await httpClient.delete(`${prefix}/${id}`)).data;
}

export async function deleteHolidayBonusByDate(
  date: string
): Promise<HolidayBonusResponse> {
  return (await httpClient.delete(`${prefix}/date/${date}`)).data;
}

export async function getHolidayBonus(id: number): Promise<HolidayBonusData> {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function getHolidayBonusByDate(
  date: string
): Promise<HolidayBonusData | null> {
  try {
    return (await httpClient.get(`${prefix}/date/${date}`)).data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
}

export async function getHolidayBonusesByDateRange(
  start: string,
  end: string
): Promise<HolidayBonusData[]> {
  return (await httpClient.get(`${prefix}/date-range?start=${start}&end=${end}`)).data;
}
